import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import CookieStorage from "./CookieStorage";
import { enableApiHeaders, onError, onSuccess } from "./Axios";

enableApiHeaders();

export const asyncStoragePersister = createAsyncStoragePersister({
  storage: CookieStorage,
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: Infinity,
      staleTime: 0,
      retry: 0,
      throwOnError: () => {
        return false;
      },
    },
    mutations: {
      onError: onError,
      onSuccess: onSuccess,
      retry: 0,
    },
  },
});
